import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, type Role } from '../lib/auth';
import PortalLogin from '../pages/auth/PortalLogin';
import { Spinner } from './ui';

const roleHome: Record<Role, string> = {
  admin: '/admin',
  oversight: '/it',
  manager: '/manager',
  staff: '/staff',
  account: '/accounts',
};

interface PortalGateProps {
  role: Role;
  children: React.ReactNode;
}

export default function PortalGate({ role, children }: PortalGateProps) {
  const { user, loading } = useAuth();

  if (loading) return <Spinner label="Checking session..." />;

  if (!user) {
    return <PortalLogin role={role} />;
  }

  if (user.role !== role) {
    return <Navigate to={roleHome[user.role]} replace />;
  }

  return <>{children}</>;
}
